export default "__VITE_ASSET__Jlz4ex_N__"